import { createClient, type SupabaseClient } from "@supabase/supabase-js";

import type { Database } from "@/integrations/supabase/types";

export type AppSupabaseClient = SupabaseClient<Database>;

type AccessTokenProvider = () => Promise<null | string>;

interface SupabaseConfig {
  key: string;
  url: string;
}

function getSupabasePublicKey(): string | undefined {
  return import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
}

function getSupabaseConfig(): SupabaseConfig {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = getSupabasePublicKey();

  if (!url || !key) {
    throw new Error("Supabase environment variables are not configured.");
  }

  return { key, url };
}

export function createSupabaseBrowserClient(accessToken: AccessTokenProvider): AppSupabaseClient {
  const { key, url } = getSupabaseConfig();

  return createClient<Database>(url, key, {
    accessToken,
    auth: {
      autoRefreshToken: false,
      detectSessionInUrl: false,
      persistSession: false,
    },
  });
}
